import { cn } from "@/lib/utils";
import { getPatientTagDefinition } from "@/lib/patient-tags";

function TagGlyph({ def }) {
  const Icon = def.icon;
  return (
    <Icon
      className={cn("size-3! shrink-0", def.glyphClassName)}
      strokeWidth={2}
      aria-label={def.label}
    >
      <title>{def.label}</title>
    </Icon>
  );
}

/**
 * Icon-only strip of patient-tag glyphs for a thread row / board card. Caps at `max` with a
 * `+N` overflow tile so rows keep a fixed height regardless of how many tags the patient has.
 * Tags stay quiet glyphs in the list — context, never alarm.
 * @param {object} props
 * @param {string[]} props.tags — patient tag keys in display order (e.g. ["loved","surgery"])
 * @param {number} [props.max] — max visible glyphs (default 3)
 * @param {string} [props.className]
 */
export function PatientTagStrip({ tags, max = 3, className }) {
  if (!tags || tags.length === 0) return null;
  const defs = tags.map((key) => getPatientTagDefinition(key)).filter(Boolean);
  if (defs.length === 0) return null;
  const visible = defs.slice(0, max);
  const overflow = defs.length - visible.length;
  return (
    <span className={cn("inline-flex items-center gap-1", className)}>
      {visible.map((def) => (
        <TagGlyph key={def.key} def={def} />
      ))}
      {overflow > 0 ? (
        <span
          className="inline-flex h-3 min-w-[14px] items-center justify-center rounded-[3px] bg-muted px-1 text-[9px] font-bold leading-none text-muted-foreground"
          title={`+${overflow} more`}
          aria-label={`${overflow} more patient tags`}
        >
          +{overflow}
        </span>
      ) : null}
    </span>
  );
}
